export default {
  EM_EVENT_CLICK: 'click',
};
